import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./approval-flow.actions";
import * as fromGraphql from "./approval-flow.graphql"
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';


@Injectable()
export class ApprovalFlowEffects {

  createApprovalFlowMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createApprovalFlowMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_APPROVAL_FLOWS,
        variables: {
          flow: action?.flow,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlow({ approvalFlow: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateApprovalFlowMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateApprovalFlowMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_APPROVAL_FLOWS,
        variables: {
          flow: action?.flow,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertApprovalFlow({ approvalFlow: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  removeApprovalFlowMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeApprovalFlowMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_APPROVAL_FLOWS,
        variables: {
          flowUniqueId: action?.flowUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteApprovalFlow({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllProcessApprovalFlows$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllProcessApprovalFlows),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_APPROVAL_FLOWS,
        fetchPolicy: 'network-only',
        variables:{
          filtering:action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.getAllProcessApprovalFlows;
            result?.response?.status ? this.store.dispatch(fromActions.loadApprovalFlows({ approvalFlows: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
